import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

// Css for matching displayed text with quill editor text
// Also has light mode color values
const textCss = css`
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  font-family: 'IBM Plex Sans', sans-serif !important;

  * img {
    max-width: 100% !important;
  }

  & :is(h2, h3, h4, h5, h6) {
    font-size: 2rem !important;
    font-weight: 500 !important;
    line-height: 1.2 !important;
    font-family: 'IBM Plex Sans', sans-serif !important;
    margin-bottom: 0.5rem !important;
  }
  & h1 {
    font-size: 2.5rem !important;
    font-weight: 500 !important;
    line-height: 1.2 !important;
    font-family: 'IBM Plex Sans', sans-serif !important;
    margin-bottom: 0.5rem !important;
  }

  & dl,
  ol,
  ul,
  p {
    font-family: 'IBM Plex Sans', sans-serif !important;
    margin: 0px !important;
    margin-bottom: 1rem !important;
  }

  & p,
  li {
    font-family: 'IBM Plex Sans', sans-serif !important;
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
  }

  & .ql-syntax {
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
  }

  iframe {
    width: 100%;
  }

  a {
    color: ${({ theme }) => theme.freecode.activeAreaColor} !important;
    text-decoration: none !important;
    :hover {
      text-decoration: underline !important;
    }
  }
`;

const textCssLightMode = css`
  color: ${colors.darkBlue2};
  & :is(h1, h2, h3, h4, h5, h6) {
    color: ${({ theme }) => theme.freecode.activeAreaColor};
  }
  & :is(h1, h2, h3, h4, h5, h6) {
    color: ${({ theme }) => theme.freecode.activeAreaColor} !important;
    span {
      color: ${({ theme }) => theme.freecode.activeAreaColor} !important;
    }
  }
`;

const textCssDarkMode = css`
  color: ${colors.lightGray} !important;
  & :is(h1, h2, h3, h4, h5, h6) {
    color: ${({ theme }) => theme.freecode.activeAreaColor} !important;
    span {
      color: ${({ theme }) => theme.freecode.activeAreaColor} !important;
    }
  }

  & .ql-syntax {
    background: ${({ theme }) => theme.freecode.headerBackground} !important;
    color: ${({ theme }) => theme.freecode.color} !important;
  }

  & .quill {
    color: ${({ theme }) => theme.freecode.color} !important;
    background: ${({ theme }) => theme.freecode.headerBackground};

    & .ql-editor {
      color: ${({ theme }) => theme.freecode.color} !important;
    }

    & .ql-toolbar {
      background: ${({ theme }) => theme.freecode.headerBackground};
      & .ql-stroke {
        stroke: ${({ theme }) => theme.freecode.color};
      }
      & .ql-fill {
        fill: ${({ theme }) => theme.freecode.color};
      }

      & button.ql-active,
      & button:hover {
        & .ql-stroke {
          stroke: ${({ theme }) => theme.freecode.activeAreaColor};
        }
        & .ql-fill {
          fill: ${({ theme }) => theme.freecode.activeAreaColor};
        }
      }
    }
  }
`;

export const EditorRefSpan = styled.span`
  ${textCss}
  ${({ isDarkMode }) => (isDarkMode ? textCssDarkMode : textCssLightMode)}
  display: block;
  width: 100%;
  ${({ displayQuill }) =>
    displayQuill &&
    css`
      position: relative;
      overflow: hidden;
      max-height: 100%;
      height: 100%;
    `}
`;

export const TitleRefSpan = styled.span`
  display: block;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
`;

export const TestTitle = styled.h1`
  font-weight: bold;
  font-size: 40px;
  line-height: 1.2;
  margin-top: 0px;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.freecode.activeAreaColor};
`;

export const TestTitleEdit = styled.input.attrs({ type: 'text' })`
  width: 100%;
  font-weight: bold;
  font-size: 40px;
  line-height: 1.2;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.freecode.headerDropShadow};
  padding: 0px;
  margin-top: -3px;
  margin-bottom: 0px;
  &:focus {
    outline: 0;
  }
  color: ${({ theme }) => theme.freecode.activeAreaColor};
  background: ${({ theme }) => theme.freecode.headerBackground};
`;

export const QuillContainer = styled.div`
  position: relative;
  display: block;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  & .quill {
    height: 100%;
    max-height: 100%;
  }
  & .ql-toolbar {
    display: block;
  }
  & .ql-container {
    border: none;
    position: relative;
    display: block;
    ${({ offsetHeight }) => css`
      height: calc(100% - 42px - ${offsetHeight});
      max-height: calc(100% - 42px - ${offsetHeight});
    `}
  }
`;

export const DescriptionContainer = styled.div`
  overflow-y: hidden;
  height: 100%;
`;

export const DescriptionScrollContainer = styled.div`
  overflow-y: ${({ hideOverflow }) => (hideOverflow ? 'hidden' : 'auto')};
  height: 100%;
`;

export const DescriptionText = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;

  & .custom-video-div {
    position: relative;
    width: 100%;
    height: 0px;
    padding-bottom: 50%;
    iframe {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
`;
